import axios from 'axios'
import { GetAxiosAuthConfig } from '../mixins/axiosAuth'


export const GetProjects = {
    // Returns a list of project objects.
    data() {
        return {
            projects: [],
            projects_loading: false,
        }
    },
    created() {
        this.GetProjects()
    },
    methods: {
        GetProjects() {
            console.log('when is this used')
            // set as loading
            this.projects_loading = true
            
            // This gets projects from the database list (which are always distinct)
            let resturl_projects = window.location.origin + '/api/projects/'

            // do two requests at once
            axios.get(resturl_projects)
            .then(response_projects => {
                this.projects = response_projects.data.results
                this.projects_loading = false
            })
            .catch(error => console.log(error))
        }
    },
}

export const GetProjectNames = {
    mixins: [GetAxiosAuthConfig],
    // Returns a list of string project names from reviewables and project model on database.
    data() {
        return {
            project_names: [],
            project_names_loading: false,
        }
    },
    created() {
        this.GetProjectNames()
    },
    methods: {
        GetProjectNames() {
            // Do all the work in django now instead of vue, simple endpoint instead!

            // set as loading
            this.project_names_loading = true

            // This gets projects from the database list (which are always distinct)
            let resturl = window.location.origin + '/api/projectnames/'

            axios.get(resturl, axios_auth_config)
                .then(response => {
                    this.project_names = response.data.projectnames
                    
                    // finished loading
                    this.project_names_loading = false
                })
                .catch(error => console.error("get next page url error", error))
        }
    },
}